import React, { FocusEventHandler, FormEventHandler } from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';

import { PERSON_FIELD_NAME } from '../../../constants/fieldNames';
import FIO from '../../shared/FIO/FIO';
import { onSecondParentChange, trimOnBlur } from '../../../helpers/handlers';
import { SecondParent } from '../../../models/child';

interface SecondParentProps {
  secondParent: SecondParent;
  inMarriage?: boolean;
  onChange: FormEventHandler;
  onBlur: FocusEventHandler;
}

const SecondParentComponent = function({
  onChange,
  onBlur,
  secondParent,
  inMarriage = false
}: SecondParentProps): JSX.Element {
  const {
    name: nameField,
    surname: surnameField,
    patronymic: patronymicField
  } = PERSON_FIELD_NAME;

  const { name, surname, patronymic, isPatronymicAbsent } = secondParent;
  const nameFields = [surnameField, nameField, patronymicField];
  const fields = { name, surname, patronymic };
  return (
    <FIO
      nameFields={nameFields}
      onChange={onChange}
      onBlur={onBlur}
      {...fields}
      isPatronymicAbsent={isPatronymicAbsent}
      inMarriage={inMarriage}
    />
  );
};

const mapStateToProps = ({ child: { secondParent } }) => ({ secondParent });
const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: onSecondParentChange(dispatch),
  onBlur: trimOnBlur('child/secondParent', dispatch)
});
const SecondParentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondParentComponent);

export { SecondParentContainer as SecondParent };
